import maplibregl from 'maplibre-gl';
import scrollama from 'scrollama';
import 'intersection-observer';
import 'maplibre-gl/dist/maplibre-gl.css';
import './src/css/style.css';

import initMap from './src/js/storyMap/initStoryMap.js';

import config from './story/config.js';
import sources from './story/sources.js';


window.maplibregl = maplibregl;
window.scrollama = scrollama;

window.addEventListener('DOMContentLoaded', async () => {
  try {
    // ✅ Optional: Remove preload class to avoid FOUC
    document.body.classList.remove('preload');



    // ✅ Call only when DOM and styles are ready
    initMap(config.default || config, sources.default || sources);
  } catch (err) {
    console.error('❌ Failed to load runtime config:', err);
  }
});

